module.exports = ".container {\n    height:1050px;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/manualkyc/manualkyc.component.css
// module id = ./src/app/manualkyc/manualkyc.component.css
// module chunks = main